import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { ButtonVariant, ButtonTone } from './Button';

const toneColor: Record<ButtonTone, string> = {
  primary: theme.color.primary,
  danger: theme.color.danger,
  neutral: theme.color.text,
};

export const buttonStyle = (variant: ButtonVariant, tone: ButtonTone) => css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.xs}px;
  font-size: ${theme.fontSize.md}px;
  cursor: pointer;
  border-radius: ${theme.radius.sm}px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${variant === 'solid' &&
  css`
    padding: ${theme.space.sm}px ${theme.space.md}px;
    border: none;
    background: ${toneColor[tone]};
    color: ${theme.color.onPrimary};
    font-weight: 600;
  `}
  ${variant === 'outline' &&
  css`
    padding: ${theme.space.sm}px ${theme.space.md}px;
    border: 1px solid ${tone === 'neutral' ? theme.color.border : toneColor[tone]};
    background: ${theme.color.surface};
    color: ${tone === 'neutral' ? theme.color.text : toneColor[tone]};
    font-weight: 500;
  `}
  ${variant === 'text' &&
  css`
    padding: 0;
    border: none;
    background: none;
    color: ${tone === 'neutral' ? theme.color.textMuted : toneColor[tone]};
    font-weight: 500;
  `}
`;
